import { useI18n } from "@core/i18n/i18n";
import { FormField } from "@ui/pages/prospect/components/form-field";
import { PtInfoFormData } from "@ui/pages/prospect/pt-info-form-data";
import { MedicalProfessionOption } from "@ui/pages/referential/use-medical-profession-options";
import { Dropdown } from "primereact/dropdown";
import React from "react";
import { Control, Controller } from "react-hook-form";

interface MedicalProfessionControllerProps {
	control?: Control<PtInfoFormData>;
	isRequired?: boolean;
	options: MedicalProfessionOption[];
}

export function MedicalProfessionController({
	control,
	isRequired = false,
	options,
}: MedicalProfessionControllerProps): JSX.Element {
	const { format } = useI18n();

	return (
		<Controller
			name="medicalProfession"
			control={control}
			rules={{
				required: isRequired ? format("global.form.field.requiredError") : undefined,
			}}
			render={({ field, fieldState }) => (
				<FormField
					title={
						isRequired
							? format("demoRequest.medicalProfessionField.title")
							: format("inviteYourPt.form.ptSection.medicalProfession.title")
					}
					errorMessage={fieldState.error?.message}
				>
					<Dropdown
						options={options}
						optionLabel="label"
						optionValue="value"
						placeholder={format("global.form.dropdown.placeholder")}
						className={fieldState.error ? "p-invalid" : undefined}
						{...field}
					/>
				</FormField>
			)}
		/>
	);
}
